module.exports = __webpack_public_path__ + "img/tag_new.edabf9c3.svg";